module.exports = __webpack_public_path__ + "static/media/rover.11305738.mp4";